import { render, staticRenderFns } from "./serviceaccountscomponent.vue?vue&type=template&id=20deee0f&"
import script from "./serviceaccountscomponent.vue?vue&type=script&lang=ts&"
export * from "./serviceaccountscomponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports